import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState, getApiErrorsState } from "@/redux/utils";

import { $PaymentMethodsModuleName } from "./paymentMethods.types";

const { isLoading, isSuccessfullyLoaded } = generateDefaultSelectors(
    $PaymentMethodsModuleName
);

const getPaymentMethods = (state: IState) =>
    getApiDataState(state, $PaymentMethodsModuleName)?.data;

const getError = (state: IState) =>
    getApiErrorsState(state, $PaymentMethodsModuleName);

export { getError, getPaymentMethods, isLoading, isSuccessfullyLoaded };
